<template>
    <div class="opacity-[0.33] z-[100] w-full h-full rounded-md
        absolute  flex justify-center items-center bg-[#6095e4ad]  ">
        <div class="flex  justify-center items-center">
            <div class="w-12 h-12 spinner-border animate-spin inline-block   border-4 rounded-full" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    // v-if="show" @click="closeInside" 
    //     data: () => ({
    //  show:true,
    // }),
    name: 'Loader',
    methods: {
        closeModal() {
            this.$emit('close', false)
        },

    },
    mounted() {
        setTimeout(() => {
            this.closeModal();
        }, 20000)
    },

}
</script>

<style>
.colorModal {
    background: #6095e4ad;
}
</style>